<template src='./index.html'></template>
<script>
import data from './data.js';
import addgs from './addgs/index.vue';
import { addzt_bcztxx, addzt_cxmrzt, addzt_cxsyqy, addzt_cxyyztxx } from '@/api/ywlxgz';

export default {
    name: 'ywlxzt_addzt',
    components: { addgs },
    props: {
        ztdiag: {
            type: Boolean,
            default: false
        },
        //用于判断是哪个界面  0:新增 1：编辑
        wikiType: {
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default: {}
        },
        title: {
            type: String,
            default: ''
        },
        pageType: {
            type: String,
            default: ''
        }
    },
    watch: {
        ztdiag: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {

                });
            }
        },
        wikiType: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.dialogWikiType = this.wikiType;
                });
            }
        },
        pageType: function(indexVal, oldVal) {
          if (indexVal) {
              this.$nextTick(() => {

              })
          }
        },
        formData: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    if (this.pageType === "0") {
                        // 业务类型规则页面
                        this.formdata = this.formData;
                        this.sobExplain = this.formData.sobExplain;
                        if (this.dialogWikiType === "1" || this.dialogWikiType === "2") {
                            // 编辑账套或复制账套
                            this.loadCompanyData();
                        }
                        if (this.wikiType !== "0") {
                            if (this.dialogWikiType === "2") {
                                // 复制账套
                                this.formdata.sobName = ""; // 账套名称置空
                                this.defaulted = false; //TODO 默认暂时直接置为非默认
                            } else {
                                this.defaulted = this.formData.defaulted === "1";
                            }
                        }
                    } else if (this.pageType === "1") {
                        // TODO 即征即退规则页面
                    }
                })
            }
        },
        title: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.dialogTitle = this.title;
                })
            }
        }
    },
    data: function() {
        return {
            defaulted: false,
            gsdiag: false,
            formlist: [],
            pagination: data.pagination,
            sobExplain: "",
            tablekey: 0,
            overlength: 0,
            headData: data.headData,
            tableData: [],
            formdata: data.formdata,
            dialogTitle: "",
            dialogWikiType: "",
            removeCompanyCodes: [],
            oldCompany: []
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            // 初始化
            if (this.pageType === "0") {
                // 业务类型规则页面
                this.formlist = data.formlist;
            } else if (this.pageType === "1") {
                // 即征即退规则页面
                this.formlist = data.requisitionFormList;
            }
        },
        loadCompanyData() {
            if (this.pageType === "0") {
                // 业务类型规则页面
                let params = {setOfBooksId: this.formdata.id, bsType: this.formdata.bsType};
                addzt_cxsyqy(params).then((res) => {
                    if (res.data.code === "1") {
                        this.tableData = res.data.data;
                    }
                })
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        defaultBtnChange(){
            if (this.pageType === "0") {
                // 业务类型规则页面
                if (this.defaulted) {
                    this.$showConfirm({message:"请确认是否将当前账套设置为默认，确认后默认应用于未单独设置过业务专项账套的企业。"})
                    this.oldCompany = this.tableData;
                    this.tableData = [];
                } else {
                    this.tableData = this.oldCompany;
                    this.oldCompany = [];
                }
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        addGs() {
            if (this.defaulted) {
                this.$message.error("默认账套不允许添加应用公司");
                return;
            }
            // 添加公司按钮点击
            this.gsdiag = true;
        },
        deleteGs() {
            if (this.pageType === "0") {
                // 业务类型规则页面
                // 删除公司
                let checkRows = this.$refs.tablebox.getSelectionval();
                const addGsInstance = this.$refs.addCompanyComponent;
                if (checkRows && checkRows.length > 0) {
                    checkRows.forEach(row => {
                        this.tableData = this.tableData.filter(item => item.companyCode !== row.companyCode && item.nsrmc !== row.nsrmc);
                        this.removeCompanyCodes.push(row.companyCode);
                        addGsInstance.selectData = addGsInstance.selectData.filter(item => item.companyCode !== row.companyCode && item.nsrmc !== row.nsrmc);
                    })
                }
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        getdata(e) {
        },
        fetchResultShow() {
            // 数据查询
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.fetchResultShow();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.fetchResultShow();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.fetchResultShow();
        },
        closediag() {
            this.$emit('closediag', false);
            this.tableData = [];
            this.defaulted = false;
        },
        gsclosediag() {
            if (this.pageType === "0") {
                // 业务类型规则页面
                const addGsInstance = this.$refs.addCompanyComponent;
                let selectData = addGsInstance.selectData;
                for (let item of selectData) {
                    let filterData = this.tableData.filter(data => data.companyCode === item.companyCode);
                    if (filterData && filterData.length > 0) {
                        continue;
                    }
                    this.tableData.push(item);
                }
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
            this.gsdiag = false;
        },
        addzt() {
            if (this.pageType === "0") {
                // 业务类型规则页面
                let verifyRes = this.addVerify();
                if (verifyRes) {
                    // 查询当前是否有默认账套
                    this.cxmrzt();
                }
            } else if (this.pageType === "1") {
                // TODO 即征即退规则页面
            }
        },
        cxmrzt() {
            // 查询默认账套方法
            if (this.defaulted) {
                let booksId = 0;
                if (this.formdata.id) {
                    booksId = this.formdata.id
                }
                addzt_cxmrzt({special: this.formdata.bsType, id: booksId}).then((res) => {
                    if (res.data.code === "1") {
                        let tip = "";
                        if (this.formdata.bsType === "1") {
                            tip = "销项税会差异";
                        } else {
                            tip = "进项税会差异";
                        }
                        let message = "“"+tip+"”已有默认账套“"+res.data.data.sobName+"”,若继续保存则将“"+res.data.data.sobName+"”置为非默认，将当前账套置为默认"
                        // 有默认账套
                        this.$showConfirm({
                            message: message,
                        }).then((result) => {
                            if (result === "confirm") {
                                this.cxyyztxx("1"); // 查询应用账套信息
                            }
                        })
                    } else {
                        // 无默认账套
                        this.cxyyztxx("0"); // 查询应用账套信息
                    }
                })
            } else {
                // 非默认账套
                this.cxyyztxx("0"); // 查询应用账套信息
            }

        },
        cxyyztxx(hasDefaulted) {
            // 查询应用账套信息
            let companyCodes = this.tableData.map(data => data.companyCode);
            let params = {companyCodes: companyCodes, bsType: this.formdata.bsType, setOfBooksId: this.formdata.id};
            addzt_cxyyztxx(params).then((res) => { // 查询当前选中企业中是否有已有账套的企业
                if (res.data.code === "1" && res.data.data && res.data.data.length > 0) {
                    // 有对应账套的企业
                    let nsrmcItem = this.tableData.filter(company => res.data.data.includes(company.companyCode)) // 过滤符合条件的对象
                        .map(company => company.nsrmc+"("+company.companyCode+")").join(",");
                    this.$showConfirm({
                        message: nsrmcItem + "已应用其他账套，若继续保存则将该公司变更为应用当前账套",
                    }).then((result) => {
                        if (result === "confirm") {
                            this.bcztxx(hasDefaulted, res.data.data);
                        }
                    })
                } else {
                    // 没有对应账套的企业
                    this.bcztxx(hasDefaulted, res.data.data);
                }

            })
        },
        bcztxx(hasDefaulted, coveredCompanyCodes) {
            // 保存账套信息
            let params = JSON.parse(JSON.stringify(this.formdata))
            params.defaulted = this.defaulted ? "1" : "0";
            params.sobExplain = this.sobExplain;
            params.hasDefaulted = hasDefaulted;
            params.coveredCompanyCodes = coveredCompanyCodes;
            params.companyCodes = this.tableData.map(data => data.companyCode);
            params.removeCompanyCodes = this.removeCompanyCodes;
            params.copyFlag = this.dialogWikiType === "2" ? "1" : "0";
            if (this.formdata.id && this.formdata.id !== 0) {
                params.setOfBooksId = this.formdata.id
            }
            addzt_bcztxx(params).then((res) => {
                if (res.data.code === "1") {
                    this.$message.success("保存成功！");
                    this.$emit('closediag', false);
                    this.tableData = [];
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        addVerify() {
            if (!this.formdata.sobName) {
                this.$message.error("账套名称不能为空");
                return false;
            }
            if (!this.formdata.bsType) {
                this.$message.error("请选择业务专项");
                return false;
            }
            return true;
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
